export default __webpack_public_path__ + "static/media/computer_vision.a74d3b72.jpg";